import React from 'react';
import {
  Box, Button, FormControl, IconButton, InputLabel,
  MenuItem, Select, Stack, TextField, Tooltip, Typography,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

/**
 * Filter strip above the orders table.
 *
 * Status dropdown + search input + manual refresh + CSV export. Search
 * is uncontrolled (server-filtered) and triggers a reload via parent —
 * we don't debounce here because the list is paginated; the user
 * usually hits the search icon or Enter.
 */
export default function OrderFilterBar({
  statusFilter, onStatusChange,
  search, onSearchChange,
  onRefresh, onExport,
  rowsShown, exportDisabled,
}) {
  return (
    <Stack direction='row' alignItems='center' spacing='8px' flexWrap='wrap' gap='8px'>
      <FormControl size='small' sx={{ minWidth: 160 }}>
        <InputLabel shrink>Status</InputLabel>
        <Select
          label='Status'
          value={statusFilter}
          onChange={(e) => onStatusChange(e.target.value)}
          displayEmpty
        >
          <MenuItem value=''>All statuses</MenuItem>
          <MenuItem value='pending'>Pending</MenuItem>
          <MenuItem value='paid'>Paid</MenuItem>
          <MenuItem value='fulfilled'>Fulfilled</MenuItem>
          <MenuItem value='cancelled'>Cancelled</MenuItem>
          <MenuItem value='refunded'>Refunded</MenuItem>
        </Select>
      </FormControl>
      <TextField
        size='small'
        placeholder='Search number or customer'
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        sx={{ maxWidth: 280, flex: '1 1 220px' }}
      />
      <Tooltip title='Search'>
        <IconButton onClick={onRefresh} size='small'>
          <SearchIcon fontSize='small' />
        </IconButton>
      </Tooltip>
      <Box flex='1' />
      <Button size='small' variant='outlined' onClick={onExport} disabled={exportDisabled}>
        Export CSV
      </Button>
      <Typography variant='caption' color='text.secondary'>
        {rowsShown} shown
      </Typography>
    </Stack>
  );
}
